<template>
  <div>
    <div class="title-section">
      <div class="title">
        <span>加入我们</span>
      </div>
      <div class="title-line"></div>
      <div class="title-subtitle">Join Us</div>
    </div>
    <div class="table" v-if="hireList.length > 0">
      <el-collapse v-model="activeNames">
        <el-collapse-item  v-for="item in hireList" :key="item.id"  :name="item.id">
          <template slot="title">
            <div class="item">
            <div>
              {{ item.title }}
            </div>
            <div>{{ item.createdTime | formatDate("YYYY-MM-DD") }}</div>
          </div>
          </template>
          <div class="ql-editor" v-html="item.content"></div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="title" style="margin-top: 20px;">
      <span>实验室地址</span>
      <div class="title-line"></div>
    </div>
    <div class="m-map" style="margin-top: 20px;">
      <baidu-map
        :center="location"
        :zoom="zoom"
      >
        <bm-marker
          :position="location"
          animation="BMAP_ANIMATION_BOUNCE"
        ></bm-marker>
        <bm-view
          style="width: 100%; height: 480px;"
        ></bm-view>
      </baidu-map>
    </div>
    <p v-if="teamDetail.address">地址: {{ teamDetail.address }}</p>
    <p v-if="teamDetail.busLine ">公交路线: {{ teamDetail.busLine }}</p>
    <hr />
    <h2 v-show="teamDetail.tel || teamDetail.email || teamDetail.otherContactInformation">联系方式</h2>
    <p v-if="teamDetail.tel">电话: {{ teamDetail.tel }}</p>
    <p v-if="teamDetail.email">邮箱: {{ teamDetail.email }}</p>
    <p v-if="teamDetail.otherContactInformation">其他: {{ teamDetail.otherContactInformation }}</p>
  </div>
</template>

<script>
import { listHire, getTeamDetail } from '@/api/api'
import '@/dist/quill.core.css'
import '@/dist/quill.snow.css'
import '@/dist/quill.bubble.css'
export default {
  name: 'hello',
  data () {
    return {
      activeNames: [],
      teamDetail: {},
      hireList: [],
      location: {
        lng: 110.424128,
        lat: 25.320556
      },
      zoom: 18
    }
  },
  mounted () {},
  created () {
    this.listHire()
    this.getTeamDetail()
  },
  beforeDestroy () {},
  methods: {
    routerTo (path, row) {
      if (row) {
        row.typeName = '招聘信息'
        sessionStorage.detail = JSON.stringify(row)
      }
      this.$router.push({
        path
      })
    },
    listHire () {
      let data = {
        pageSize: 10
      }
      listHire(data).then((res) => {
        if (res.code === 200) {
          this.hireList = res.data
          if (this.hireList.length > 0) {
            let arr = []
            this.hireList.forEach(i => {
              arr.push(i.id)
            })
            this.activeNames = arr
          }
        }
      })
    },
    getTeamDetail () {
      getTeamDetail().then((res) => {
        if (res.code === 200) {
          this.teamDetail = res.data
        }
      })
    }
  }
}
</script>
<style scoped>
.title-section {
  position: relative;
  margin-bottom: 32px;
}

.title {
  font-size: 36px;
  line-height: 1.4;
  color: #2f4f4f;
  font-weight: 700;
  letter-spacing: 3px;
  animation: titleFloatIn 0.8s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

.title-subtitle {
  position: absolute;
  right: 0;
  top: 10px;
  font-size: 14px;
  color: #888;
  letter-spacing: 8px;
  text-transform: uppercase;
  animation: subtitleFadeIn 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.5s forwards;
  opacity: 0;
}

@keyframes titleFloatIn {
  from {
    opacity: 0;
    transform: translateY(-40px);
    letter-spacing: 10px;
  }
  to {
    opacity: 1;
    transform: translateY(0);
    letter-spacing: 3px;
  }
}

@keyframes subtitleFadeIn {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.title-line {
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #2f4f4f, #5a8a8a);
  border-radius: 2px;
  animation: lineSlideIn 1s cubic-bezier(0.22, 1, 0.36, 1) 0.3s forwards;
  transform-origin: left;
  transform: scaleX(0);
}

@keyframes lineSlideIn {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}
.table {
  margin-top: 20px;
  border: 3px solid #2f4f4f;
  padding: 5px 20px;
  box-sizing: border-box;
}
.item {
  width: 1030px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  font-size: 17px;
}
.item + .item {
  border-top: 1px solid #2f4f4f8c;
}
.item:hover {
  cursor: pointer;
  color: #d4af37;
}
.m-map-container {
  width: 1200px;
  text-align: center;
  margin: 0 auto;
  background: #fff;
}
.m-map {
  margin: 0 auto;
}
.BMap_cpyCtrl .BMap_noprint.anchorBL {
  display: none!important;
}

.anchorBL {
  display: none!important;
}
</style>
